
<header class="np-header">
  @if (isSearchVisible) {
    <div id="search" #search>
      <form id="search-form" action="https://www.office.com/search?auth=2" target="_blank" method="get">
        <em class="icon-search" aria-hidden="true"></em>
        <input id="search-text" autocomplete="off" type="text" name="q" spellcheck="false"
          placeholder="what can we help you find?" aria-label="what can we help you find?">
          <button id="search-clear" type="reset" title="clear" aria-label="clear search text">
            clear
          </button>
          <button id="search-button" type="submit" title="search" aria-label="submit search">
            <em class="icon-arrow-right"></em>
          </button>
        </form>
      </div>
    }
    <span id="toggle-search" #toggleSearch class="icon-search" role="button" aria-label="Toggle search form" (click)="toggleSearchVisibility()" aria-pressed="false">
      <em>enterprise<br>search</em>
    </span>

    <!--
    <h4 id="login" class="flex float-right">
      <a> welcomeMessage </a>
    </h4>
    -->
    @if (isMenuVisible) {
      <div id="menu" #menu>
        <div id="nav-container">
          <nav class="mainnav" aria-label="homepage example" aria-hidden="true">
            <ul>
              @for (item of menuItems; track item) {
                <li>
                  <a href="{{item.link}}">{{ item.label }}</a>
                </li>
              }
            </ul>
          </nav>
          <hr class="separator">
        </div>
        <h3>quick links</h3>
        <ul>
          <li><a href="http://inside.chevron.com">inside home</a></li>
          <li><a href="http://whitepages.chevron.com">people finder</a></li>
          <li><a href="http://chaos.chevron.com">chaos</a></li>
        </ul>
        <hr class="separator">
        <ul>
          <li><a href="https://www.timeanddate.com/worldclock/" target="_blank" rel="noopener noreferrer">world clock</a>
        </li>
        <li><a href="https://www.wunderground.com/" target="_blank" rel="noopener noreferrer">weather</a></li>
        <li><a href="https://www.chevron.com/" target="_blank" rel="noopener noreferrer">chevron.com</a></li>
      </ul>
    </div>
  }
  <div id="toggle-menu" #toggleMenu class="toggle-menu" role="button" aria-label="Toggle top menu navigation" (click)="toggleMenuVisibility()">
    <span class="icon-menu-hamburger"><em>menu</em></span>
    <span class="icon-remove"></span>
  </div>
  <div id="sitename">
    <a id="hallmark" routerlink="/" href="/"></a>
    <div>
      <a href="/"> {{ sitename }} </a>
    </div>
  </div>

</header>